import Vue from 'vue';
import { candidateStatus } from '@/enums';
import Company from '@/orm/models/Company/Company';
import api from '@/api';

export const kanbanMutations = Object.freeze({
  CREATE_STAGE: 'CREATE_STAGE',
  DELETE_STAGE: 'DELETE_STAGE',
  SET_STAGES: 'SET_STAGES',
  UPDATE_STAGE: 'UPDATE_STAGE',
});

const initialState = () => ({
  stages: [
    {
      name: 'Приглашено',
      id: 1,
      status: candidateStatus.INVITED,
      system: true,
      sort: 1,
    },
    {
      name: 'Прошли интервью',
      id: 2,
      status: candidateStatus.INTERVIEWED,
      system: true,
      sort: 2,
    },
    {
      name: 'Приглашен на очное интервью',
      id: 3,
      status: candidateStatus.INOFFICE_INTERVIEW,
      system: true,
      sort: 3,
    },
    {
      name: 'Предложение о работе',
      id: 4,
      status: candidateStatus.JOB_OFFER,
      system: true,
      sort: 4,
    },
    {
      name: 'Выход на работу',
      id: 5,
      status: candidateStatus.HIRED,
      system: true,
      sort: 5,
    },
    {
      name: 'Отказ',
      id: 6,
      status: candidateStatus.DECLINED,
      system: true,
      sort: 6,
    },
  ],
});

const mutations = {
  [kanbanMutations.SET_STAGES](state, payload) {
    state.stages = payload;
  },
  [kanbanMutations.CREATE_STAGE](state, payload) {
    const stageIndex = state.stages.findIndex((s) => s.id === payload.id);

    if (stageIndex !== -1) {
      Vue.set(state.stages, stageIndex, payload);
    } else {
      state.stages.push(payload);
    }
  },
  [kanbanMutations.DELETE_STAGE](state, { id }) {
    state.stages = state.stages.filter((s) => s.id !== id);
  },
  [kanbanMutations.UPDATE_STAGE](state, payload) {
    const stageIndex = state.stages.findIndex((s) => s.status === payload.status);
    Vue.set(state.stages, stageIndex, payload);
  },
};

const actions = {
  async push({ commit }, payload) {
    commit(kanbanMutations.CREATE_STAGE, payload);
  },
  async create({ dispatch }, payload) {
    const company = Company.all()[0];
    const { status, ...data } = payload;
    const result = await api.post(`/companies/${company.id}/candidate-statuses`, data);
    dispatch('push', result.data.data);
  },
  async update({ commit }, payload) {
    const {
      id, name, active, sort,
    } = payload;
    const result = await api.put(`/candidate-statuses/${id}`, {
      name,
      active,
      sort,
    });
    commit(kanbanMutations.UPDATE_STAGE, result.data.data);
  },
  async delete({ commit }, payload) {
    const { id, newStatusId } = payload;
    commit(kanbanMutations.DELETE_STAGE, payload);
    await api.post(`/candidate-statuses/${id}/destroy`, { newStatusId });
  },
  async sort(_, payload) {
    await api.post('/candidate-statuses/change-sort', {
      statuses: payload,
    });
  },
  deleteTemp({ commit }, payload) {
    commit(kanbanMutations.DELETE_STAGE, payload);
  },
  async fetch({ commit }) {
    await Company.api().fetch();
    const company = Company.all()[0];
    if (company?.candidateStatuses) {
      commit(kanbanMutations.SET_STAGES, company.candidateStatuses);
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
};
